import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import ArrowRight from '@/presentation/assets/svg/ArrowRight.svg'
import Calendar from '@/presentation/assets/svg/Calendar'
import EditIcon from '@/presentation/assets/svg/Edit'
import AlterationStatusItem from '@/presentation/pages/Alteration/components/AlterationStatusItem'
import { ROUTES } from '@/services/constants/routes'
import useNavigateWithOrderCode from '@/services/hooks/useNavigateWithOrderCode'
import safeParseDate from '@/services/utils/safeParseDate'

const Item = ({ alteration }: any, key: any) => {
  const { t } = useTranslation()

  const navigate = useNavigateWithOrderCode()

  const handleGoToRoomItem = (
    roomId: string | undefined,
    itemId: string | undefined
  ) => {
    if (roomId && itemId) {
      navigate(`${ROUTES.ALTERATION_SENT_ITEM}/${roomId}/${itemId}`)
    }
  }

  return (
    <div
      key={key}
      className="mb-4 flex w-full cursor-pointer flex-col rounded-xl bg-white shadow-md"
      onClick={() =>
        handleGoToRoomItem(alteration?.room_id, alteration?.item_id)
      }
    >
      <div
        className="h-20 w-full rounded-t-md bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${alteration?.item?.image})` }}
      />

      <div className="flex flex-col items-start justify-start gap-y-2 rounded-b-xl border border-t-0 border-gray-400 p-4 text-left">
        <div className="flex w-full items-center justify-between gap-y-2">
          <span className="text-xl font-semibold text-gray-600">
            {alteration?.item?.id === 'building'
              ? alteration?.item?.name
              : `${alteration?.item?.name} | ${alteration?.room?.name}`}
          </span>

          <img src={ArrowRight} alt="Right arrow icon" />
        </div>

        <div className="flex gap-6">
          <span className="flex items-center gap-1 text-sm text-gray-500">
            <Calendar width={16} height={16} color={'#858585'} />

            {dayjs(safeParseDate(alteration?.created_at)).format('DD/MM/YYYY')}
          </span>

          <span className="flex items-center gap-1 text-sm text-gray-500">
            <EditIcon width={16} height={16} color={'#858585'} />

            {alteration?.done
              ? t('DONE', 'Realizada')
              : t('NOT_DONE', 'Não realizada')}
          </span>
        </div>

        <AlterationStatusItem status={alteration?.status || ''} />
      </div>
    </div>
  )
}

export default Item
